/* ==========================================================================
   Booking form — step controller
   Ships as: assets/event-booking.js  (loaded with defer)

   Progressive enhancement: without this file the form still works. Every
   fieldset is visible and it posts as one long form. This script hides the
   non-current steps and validates each one before letting the user advance.

   No dependencies — the theme's jQuery is not required.
   ========================================================================== */

(function () {
  'use strict';

  var form = document.getElementById('booking-form');
  if (!form) return;

  var steps    = Array.prototype.slice.call(form.querySelectorAll('.event-step'));
  var trackers = Array.prototype.slice.call(form.querySelectorAll('#tracker li'));
  var bar      = document.getElementById('progress-bar');
  var status   = document.getElementById('step-status');
  var count    = document.getElementById('step-count');
  var btnNext  = document.getElementById('btn-next');
  var btnBack  = document.getElementById('btn-back');

  if (!steps.length) return;

  var current = 0;
  var last = steps.length - 1;

  // Signals to CSS that stepping is active. Until this runs, all steps show
  // and the plain submit button is the only control.
  form.setAttribute('data-js', '');
  btnNext.hidden = false;

  /* ---- validation ------------------------------------------------------ */

  function fieldsIn(step) {
    return Array.prototype.slice.call(
      step.querySelectorAll('input, select, textarea')
    ).filter(function (el) { return !el.disabled; });
  }

  function messageFor(el) {
    if (el.validity.valueMissing) {
      return el.type === 'radio' ? 'Please choose an option.' : 'This field is required.';
    }
    if (el.type === 'email' && (el.validity.typeMismatch || el.validity.patternMismatch)) {
      return 'Enter a valid email address.';
    }
    if (el.type === 'tel' && el.validity.patternMismatch) {
      return 'Enter a 10-digit mobile number.';
    }
    return el.validationMessage || 'Please check this field.';
  }

  function clearErrors(step) {
    step.querySelectorAll('.event-error').forEach(function (p) { p.textContent = ''; });
    fieldsIn(step).forEach(function (el) { el.removeAttribute('aria-invalid'); });
  }

  function showError(step, el) {
    var slot = step.querySelector('[data-error-for="' + el.name + '"]');
    if (slot) slot.textContent = messageFor(el);
    el.setAttribute('aria-invalid', 'true');
  }

  function validate(step) {
    clearErrors(step);

    var seen = {};
    var firstBad = null;

    fieldsIn(step).forEach(function (el) {
      // radio groups report per-input; only handle each group once
      if (el.type === 'radio') {
        if (seen[el.name]) return;
        seen[el.name] = true;
        var group = step.querySelectorAll('input[name="' + el.name + '"]');
        var chosen = Array.prototype.some.call(group, function (r) { return r.checked; });
        var required = Array.prototype.some.call(group, function (r) { return r.required; });
        if (required && !chosen) {
          showError(step, el);
          if (!firstBad) firstBad = el;
        }
        return;
      }

      if (!el.checkValidity()) {
        showError(step, el);
        if (!firstBad) firstBad = el;
      }
    });

    if (firstBad) firstBad.focus();
    return !firstBad;
  }

  /* ---- review panel ---------------------------------------------------- */

  function fillReview() {
    form.querySelectorAll('[data-review]').forEach(function (slot) {
      var name = slot.getAttribute('data-review');
      var field = form.querySelector('[name="' + name + '"]');
      var value = '';

      if (field && field.type === 'radio') {
        var checked = form.querySelector('[name="' + name + '"]:checked');
        value = checked ? checked.value : '';
      } else if (field) {
        value = field.value;
      }

      // phone is entered as 10 bare digits (see event-phone-input); show
      // the complete number here so the review matches what actually sends
      if (name === 'phone' && value) value = '+91 ' + value;

      slot.textContent = value || '—';
    });

    // multi-select groups (e.g. the design checkboxes) aren't one named
    // field — join whichever [data-interest-option] boxes are checked
    form.querySelectorAll('[data-review-checklist]').forEach(function (slot) {
      var checked = Array.prototype.slice.call(
        form.querySelectorAll('[data-interest-option]:checked')
      ).map(function (el) { return el.getAttribute('data-interest-option'); });
      slot.textContent = checked.length ? checked.join(', ') : '—';
    });
  }

  /* ---- rendering ------------------------------------------------------- */

  function render(focusStep) {
    steps.forEach(function (step, i) { step.hidden = i !== current; });

    trackers.forEach(function (li, i) {
      var marker = li.querySelector('.event-tracker__marker');
      if (i < current) {
        li.setAttribute('data-state', 'done');
        if (marker) marker.textContent = '✓';
      } else if (i === current) {
        li.setAttribute('data-state', 'current');
        if (marker) marker.textContent = String(i + 1);
      } else {
        li.removeAttribute('data-state');
        if (marker) marker.textContent = String(i + 1);
      }
    });

    bar.style.width = ((current + 1) / steps.length * 100) + '%';
    count.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
    btnBack.hidden = current === 0;
    btnNext.textContent = current === last ? 'Submit enquiry' : 'Continue';

    var legend = steps[current].querySelector('legend');
    status.textContent = 'Step ' + (current + 1) + ' of ' + steps.length +
      (legend ? ': ' + legend.textContent.trim() : '');

    if (current === last) fillReview();

    // move focus to the step so keyboard and screen-reader users land in it
    if (focusStep !== false) {
      var target = steps[current];
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  function goTo(index, focusStep) {
    current = Math.max(0, Math.min(index, last));
    render(focusStep);
  }

  /* ---- events ---------------------------------------------------------- */

  btnNext.addEventListener('click', function () {
    if (!validate(steps[current])) return;
    if (current === last) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
    goTo(current + 1);
  });

  btnBack.addEventListener('click', function () { goTo(current - 1); });

  form.querySelectorAll('[data-goto]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goTo(parseInt(btn.getAttribute('data-goto'), 10) - 1);
    });
  });

  // Enter should advance a step, not submit a half-filled form
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target.tagName === 'TEXTAREA') return;
    e.preventDefault();
    btnNext.click();
  });

  // clear a field's error as soon as it is corrected
  form.addEventListener('input', function (e) {
    if (!e.target.name) return;
    var slot = form.querySelector('[data-error-for="' + e.target.name + '"]');
    if (slot && slot.textContent) { slot.textContent = ''; e.target.removeAttribute('aria-invalid'); }
  });
  form.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') return;
    var slot = form.querySelector('[data-error-for="' + e.target.name + '"]');
    if (slot) slot.textContent = '';
  });

  /* ---- submission ------------------------------------------------------
     With JS running we intercept the native submit and POST JSON to the
     meeting-scheduler-app API via fetch, then redirect client-side. This
     keeps the step UI in place if the request fails (inline error, no lost
     progress). Without JS, the form's native action/method takes over and
     the API replies with a 303 redirect to the `redirectTo` field instead
     of JSON — see meeting-scheduler-app/src/routes/bookings.ts. */

  var formError = document.getElementById('form-error');
  var submitting = false;

  function serialize() {
    var data = {};
    var elements = form.elements;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el.name || el.disabled) continue;

      if (el.type === 'checkbox' && el.name === 'interests') {
        if (!el.checked) continue;
        if (!data.interests) data.interests = [];
        data.interests.push(el.value);
        continue;
      }
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (!el.checked) continue;
        data[el.name] = el.type === 'checkbox' ? true : el.value;
        continue;
      }
      data[el.name] = el.value;
    }
    data.sourceUrl = window.location.href;
    return data;
  }

  function showFormError(message) {
    if (!formError) return;
    formError.hidden = false;
    formError.textContent = message;
    formError.focus();
  }

  function submitBooking() {
    if (submitting) return;
    submitting = true;
    if (formError) { formError.hidden = true; formError.textContent = ''; }
    var originalLabel = btnNext.textContent;
    btnNext.disabled = true;
    btnNext.textContent = 'Submitting…';

    var payload = serialize();
    var redirectTo = payload.redirectTo || '/';

    fetch(form.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.json || !result.json.ok) {
          var message = (result.json && (result.json.error ||
            (result.json.details && result.json.details.join(', ')))) ||
            'Something went wrong. Please try again.';
          throw new Error(message);
        }
        var params = new URLSearchParams({
          ref: result.json.reference || '',
          day: payload.preferredDay || '',
          time: payload.preferredTime || ''
        });
        /* Analytics hook — see EVENT-PAGE-PLAN.md §7
           window.dataLayer && window.dataLayer.push({ event: 'booking_submitted' }); */
        window.location.href = redirectTo + (redirectTo.indexOf('?') > -1 ? '&' : '?') + params.toString();
      })
      .catch(function (err) {
        submitting = false;
        btnNext.disabled = false;
        btnNext.textContent = originalLabel;
        showFormError(err.message || 'Something went wrong. Please try again.');
      });
  }

  // final guard: every step must pass before submitting
  form.addEventListener('submit', function (e) {
    for (var i = 0; i < steps.length; i++) {
      if (!validate(steps[i])) { e.preventDefault(); goTo(i); return; }
    }

    // the phone field only ever collects 10 bare digits (validated against
    // that); the +91 country code lives in the fixed badge next to it, not
    // in the field's value — stitch the two together right here, once
    // everything has validated, so what actually sends is the full number
    var phone = form.querySelector('[name="phone"]');
    if (phone && phone.value && phone.value.indexOf('+') !== 0) {
      phone.value = '+91' + phone.value;
    }

    e.preventDefault();
    submitBooking();
  });

  /* ---- day-dependent time slots ------------------------------------------
     The two days run different hours, so step 2 has one slot list per day
     (both rendered — see event-booking.liquid). Once a day is picked, hide
     the other day's list and clear any stale selection in it so a leftover
     checked radio from the day not chosen can't be submitted. Nothing runs
     here until a day is actually picked, so the no-JS fallback (both lists
     visible, everything reachable) is what shows before that. */
  var dayRadios = Array.prototype.slice.call(form.querySelectorAll('input[data-day]'));
  var slotGroups = Array.prototype.slice.call(form.querySelectorAll('[data-day-slots]'));

  function syncDaySlots() {
    var checked = form.querySelector('input[name="preferredDay"]:checked');
    var day = checked ? checked.getAttribute('data-day') : null;
    if (!day) return;

    slotGroups.forEach(function (group) {
      var match = group.getAttribute('data-day-slots') === day;
      group.hidden = !match;
      if (!match) {
        Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'))
          .forEach(function (r) { r.checked = false; });
      }
    });
  }

  dayRadios.forEach(function (r) { r.addEventListener('change', syncDaySlots); });

  goTo(0, false);
})();
